// Angular imports
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Component imports
import { AddPropertyComponent } from './property-module/add-property/add-property.component';
import { ContactUsComponent } from './shared-components/contact-us/contact-us.component';
import { CommonUserAuthenticationLayoutComponent } from './user-components/common-user-authentication-layout/common-user-authentication-layout.component';
import { LoginComponent } from './user-components/login/login.component';
import { QuickPaymentComponent } from './user-components/quick-payment/quick-payment.component';
import { ForgotPasswordComponent } from './user-components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './user-components/reset-password/reset-password.component';
import { RetrieveUsernameOrValidateEmailComponent } from './user-components/retrieve-username-or-validate-email/retrieve-username-or-validate-email.component';
import { ValidateUserComponent } from './user-components/validate-user/validate-user.component';
import { UserDashboardComponent } from './shared-components/user-dashboard/user-dashboard.component';
import { ResendValidationEmailComponent } from './user-components/resend-validation-email/resend-validation-email.component';
import { UserRegistrationComponent } from './user-components/user-registration/user-registration.component';
import { GoogleCallbackComponent } from './user-components/google-callback/google-callback.component';
import { AboutCiranetComponent } from './static-pages/about-ciranet/about-ciranet.component';
import { PrivacyPolicyComponent } from './static-pages/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './static-pages/terms-and-conditions/terms-and-conditions.component';

// Guard imports
import { AuthGuard } from './_guards/auth.guard';
import { AlreadyLoggedInGuard } from './_guards/already-logged-in.guard';

const appRoutes: Routes = [
  {
    path: 'home',
    component: UserDashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'property',
    children: [
      {
        path: 'add-property',
        component: AddPropertyComponent,
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: 'accounts',
    loadChildren: () =>
      import('./accounts-module/accounts.module').then((m) => m.AccountsModule)
  },
  {
    path: 'community',
    loadChildren: () =>
      import('./community-module/community.module').then(
        (m) => m.CommunityModule
      )
  },
  {
    path: 'meeting-hub',
    loadChildren: () =>
      import('./meeting-hub-module/meeting-hub.module').then(
        (m) => m.MeetingHubModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'google-callback',
    component: GoogleCallbackComponent
  },
  {
    path: 'user',
    component: CommonUserAuthenticationLayoutComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [AlreadyLoggedInGuard]
      },
      { path: 'forgotpassword', component: ForgotPasswordComponent },
      { path: 'resetpassword', component: ResetPasswordComponent },
      { path: 'validate', component: RetrieveUsernameOrValidateEmailComponent },
      { path: 'signup', component: UserRegistrationComponent },
      { path: 'quickpayment', component: QuickPaymentComponent },
      { path: 'validateUser', component: ValidateUserComponent },
      { path: 'resendemail', component: ResendValidationEmailComponent }
    ]
  },
  {
    path: ':communityId/:customerId/one-time-payment',
    loadChildren: () =>
      import('./shared-module/one-time-payment/quick-pay.module').then(
        (m) => m.QuickPayModule
      )
  },
  {
    path: 'cirahelp',
    data: {
      outletOnly: true
    },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./help-module/help.module').then((m) => m.HelpModule)
  },
  {
    path: 'about-ciranet',
    component: AboutCiranetComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent
  },
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(appRoutes, { scrollPositionRestoration: 'top' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
